const { required, minLength, sameAs, helpers } = require('vuelidate/lib/validators')

/**
 * Regular expression for password validation.
 *
 * This regex ensures that the string contains:
 * - At least one lowercase letter
 * - At least one uppercase letter
 * - At least one number
 * - At least one special character
 *
 * The regex does not enforce any minimum or maximum length constraints.
 *
 * @const {RegExp}
 *
 * @example
 * /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\da-zA-Z]).*$/
 *
 * // --- Breakdown ---
 * // ^                   - Start of the string
 * // (?=.*\d)            - Positive Lookahead: Requires at least one digit
 * // (?=.*[A-Z])          - Positive Lookahead: Requires at least one uppercase letter
 * // (?=.*[a-z])          - Positive Lookahead: Requires at least one lowercase letter
 * // (?=.*[^\da-zA-Z])   - Positive Lookahead: Requires at least one special character (non-alphanumeric)
 * // .* - Matches any character, zero or more times (no length constraint)
 * // $                   - End of the string
 */
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\da-zA-Z]).*$/;
// const PASSWORD_REGEX = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\da-zA-Z]).{8,}$/;  // force min 8 characters

const letterNumberSpecialCharacter = helpers.regex('letterNumberSpecialCharacter', PASSWORD_REGEX);

export default {
    props: ['view'],
    validations: {
        input_password: {
            required,
            minLength: minLength(8),
            // maxLength: maxLength(20),
            letterNumberSpecialCharacter: letterNumberSpecialCharacter
        },
        input_password_v: { // just for lazy validation
            required,
            minLength: minLength(8),
            // maxLength: maxLength(20),
            letterNumberSpecialCharacter: letterNumberSpecialCharacter
        },
        input_confirm_password: {
            required,
            sameAsPassword: sameAs('input_password')
        },
        input_confirm_password_v: {
            required,
            sameAsPassword: sameAs('input_password_v')
        }
    },
    data: function() {
        return {
            checkbox_logout_all_devices: true,
            input_password: '',
            input_password_v: '', // just for lazy validation
            input_confirm_password: '',
            input_confirm_password_v: '' // just for lazy validation
        }
    },
    computed: {
      showPasswordFeedback() {
        return this.shouldShowFeedback('input_password');
      },
      showConfirmPasswordFeedback() {
        return this.shouldShowFeedback('input_confirm_password');
      },
      passwordClass() {
        return this.validationClass('input_password');
      },
      confirmPasswordClass() {
        return this.validationClass('input_confirm_password');
      }
    },
    methods: {
        shouldShowFeedback(field) {
            if (this[field] === '') return false;

            return this.$v[field].$invalid;
        },
        validationClass(field) {
            if (this[field] === '') return '';

            const validationField = this.$v[field];
            if (!validationField) return '';

            return validationField.$invalid ? 'text-danger' : '';
        },
        changePasswordSubmit(){
            this.$emit('change-password-submit');
        },
        dontHaveAccount(){
            this.$emit('dont-have-account', 'change-password');
        },
        goBackToLogin(){
            this.$emit('go-back-to-login', 'change-password');
        },
        onChange(key, value) {
            this[key] = value;
            this.$v[key].$touch();
        }
    },
    watch: {
        '$v.$invalid': {
            handler: function(newVal, oldVal) {
                if( !newVal ) {
                    this.$toast.clear();
                }
            },
            deep: true
        },
        '$v.input_password_v.required': {
            handler: function(newVal, oldVal) {
                if( !newVal ) {
                    this.$toast.error( window.getInnerComponent(`${this.view.translations.change_password_label_new_password} ${this.view.translations.label_required_v5}`) );
                }
            },
            deep: true
        },
        '$v.input_password_v.minLength': {
            handler: function(newVal, oldVal) {
                if( !newVal ) {
                     this.$toast.error( window.getInnerComponent(this.view.translations.password_must_be_at_least_8_characters_long) );
                }
            },
            deep: true
        },
        // '$v.input_password_v.maxLength': {
        //     handler: function(newVal, oldVal) {
        //         if( !newVal ) {
        //             this.$toast.error( window.getInnerComponent(this.view.translations.label_password_must_have_a_maximum_of_x_characters_v5) );
        //         }
        //     },
        //     deep: true
        // },
        '$v.input_password_v.letterNumberSpecialCharacter': {
            handler: function(newVal, oldVal) {
                if( !newVal ) {
                    this.$toast.error( window.getInnerComponent(this.view.translations.must_contain_letters_numbers_special_characters) );
                }
            },
            deep: true
        },

        '$v.input_confirm_password_v.required': {
            handler: function(newVal, oldVal) {
                if( !newVal ) {
                    this.$toast.error( window.getInnerComponent(`${this.view.translations.label_repeat_password_v5} ${this.view.translations.label_required_v5}`) );
                }
            },
            deep: true
        },
        '$v.input_confirm_password_v.sameAsPassword': {
            handler: function(newVal, oldVal) {
                if( !newVal && this.input_confirm_password_v !== undefined && this.input_confirm_password_v !== null && this.input_confirm_password_v !== '') {
                    this.$toast.error( window.getInnerComponent(this.view.translations.label_different_passwords_v5) );
                }
            },
            deep: true
        },
    },
    mounted(){
        let vm = this;
        $(window).on('load', function(){
            if(vm.view.data.back_toastr_message !== false){
                vm.$toast[vm.view.data.back_toastr_message_type]( window.getInnerComponent(vm.view.data.back_toastr_message) )
            }
        })
    }
}



// WEBPACK FOOTER //
// ./resources/office/js/mixins/changePasswordForm.js